export default __webpack_public_path__ + "static/media/second.83b492a5.svg";